import { PersonCard } from "@/pages/ContactsPage/Components/PersonCard";
import { ContactsTabs } from "@/pages/ContactsPage/Components/ContactsTabs";
import { contactsIsEditSelector } from "@/pages/ContactsPage/slice";
import { useAppSelector } from "@/services/store";
import { ControlButtons } from "@/pages/ContactsPage/Components/ControlButtons";
import { LeftSectionList } from "../LeftSectionList";
import { RightSectionList } from "../RightSectionList";
import styles from "./styles.module.scss";

export const Layout = () => {
  const isEdit = useAppSelector(contactsIsEditSelector);
  return (
    <div className={styles.root}>
      <div className={styles["left-section"]}>
        <PersonCard isEdit={isEdit} showEdit />
        <div className={styles["tabs"]}>
          <ContactsTabs />
        </div>
        <div className={styles["left-section-list"]}>
          <LeftSectionList />
        </div>
      </div>
      <div className={styles["right-section"]}>
        <RightSectionList />
      </div>
      <div className={styles["control-buttons"]}>
        {isEdit && (
          <ControlButtons className={styles["control-buttons-inner"]} tabType="activities" />
        )}
      </div>
    </div>
  );
};
